// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"91":"bbf2aac0","300":"17463ee1","493":"c1ca421c","623":"09e60547","930":"34455690","964":"3e793c56"}[chunkId] + ".792362f3a261.chunk.js";
};